module.exports = __webpack_public_path__ + "img/planta_09.0751b9c9.png";